import React from 'react';

import {createInteractionCallback} from '@optimaxdev/analytics/desktop/lib/gaEvent/index';
import {Icon, Cart, ArrowLeft} from '@optimaxdev/icons';
import classNames from 'classnames';
import {Link} from 'react-router-dom';

import {useFeature} from 'components/feature';
import {CHECKOUT_GENERAL} from 'constants/analytics/events/checkout';

import s from './cartHeader.scss';

type PropsType = {
    count: number;
    isScrollOnTop: boolean;
};

/**
 * Cart Header for checkout page
 * @constructor
 */
export const CartHeader: React.FC<PropsType> = ({count, isScrollOnTop}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <section
            className={classNames(s.wrapper, {
                [s.onTop]: isScrollOnTop,
                [s.wrapperFacelift]: isFacelift,
            })}
        >
            <div className={s.top}>
                <h1 className={s.title}>
                    Your cart<span className={s.count}>({count})</span>
                </h1>
                <Link
                    onClick={createInteractionCallback(CHECKOUT_GENERAL, {
                        message: 'Back To Cart',
                        version: 'D',
                    })}
                    aria-label="Go to the cart page"
                    className={s.link}
                    to="/checkout/cart"
                >
                    {isFacelift ? (
                        'Edit Cart'
                    ) : (
                        <span className={s.backToCartIcon} role="presentation">
                            <Icon className={s.arrow} icon={ArrowLeft} />
                            <Icon className={s.cart} icon={Cart} size="responsive" />
                        </span>
                    )}
                </Link>
            </div>
        </section>
    );
};
